<script>
import { cargoDetailList } from '@/api/business/containerLadingOrderCargo';

export default {
  name: 'LadingCargoDetailMultiSelect',
  components: {},
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ladingOrderId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      multipleDisabled: true,
      data: []
    };
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    open() {
      Object.assign(this.$data, this.$options.data());
      this.show = true;
      this.onQuery();
    },
    onQuery() {
      this.loading = true;
      const params = {
        ladingOrderId: this.ladingOrderId
      };
      cargoDetailList(params).then(res => {
        this.data = res.data || [];
      }).finally(() => {
        this.loading = false;
        this.$nextTick(() => {
          this.$refs.table.clearSelection();
          this.data.forEach(row => {
            if ((this.value || []).includes(row.orderCargoDetailId)) {
              this.$refs.table.toggleRowSelection(row);
            }
          })
        })
      });
    },
    handleSelectionChange(rows) {
      this.multipleDisabled = !rows.length
    },
    onSubmit() {
      const rows = this.$refs.table.selection
      this.$emit('input', rows.map(item => item.orderCargoDetailId))
      this.$emit('complete', [...rows])
      this.show = false
    }
  }
}
</script>

<template>
  <el-dialog
    title="选择货物"
    :visible.sync="show"
    width="800px"
    append-to-body
  >
    <div class="padding-bottom-sm">
      <div class="block-header warning inline-block margin-right-sm">如果还未维护箱子数据，请先在"集装箱托单详情/托单货物信息/箱子清单"中进行维护</div>
    </div>
    <eu-loading v-if="loading" style="height: 300px;"></eu-loading>
    <el-table
      v-else
      ref="table"
      :data="data"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column prop="cargoNo" label="货物编号"></el-table-column>
      <el-table-column prop="cargoTypeName" label="货物类型"></el-table-column>
      <el-table-column prop="cargoSpecName" label="规格"></el-table-column>
      <el-table-column prop="cargoAttrUniNo" label="箱号"></el-table-column>
      <el-table-column prop="cargoAttrSealNo" label="封签号"></el-table-column>
      <el-table-column prop="cargoAttrLoadBoxDate" label="装箱日"></el-table-column>
      <el-table-column prop="cargoAttrName" label="货物名称"></el-table-column>
    </el-table>
    <template #footer>
      <el-button @click="show = false">取消</el-button>
      <el-button :disabled="multipleDisabled" class="eu-submit-btn" type="primary" @click="onSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
</style>